import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import DialogActions from '@mui/material/DialogActions';
import Button from '@classify/react-core-components/Button';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import { translate } from '@openclassrooms/translations';

interface Props {
  onConfirm?: () => void;
  onCancel?: () => void;
}

export default function FileDownloadDialog({ onConfirm = () => {}, onCancel = () => {} }: Props) {
  return (
    <Dialog disableScrollLock open onClose={onCancel}>
      <DialogTitle>{translate('get_business_content.confirmation_dialog.title')}</DialogTitle>

      <DialogContent>{translate('get_business_content.confirmation_dialog.text')}</DialogContent>

      <DialogActions>
        <Button variant="tertiary" onClick={onCancel}>
          {translate('global.word.cancel')}
        </Button>

        <Button
          variant="tertiary"
          endIcon={<OpenInNewIcon />}
          onClick={onConfirm}
          data-event="Navigation|Redirection::External|Download"
        >
          {translate('global.word.download')}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
